import React, { Component } from 'react';
import BenMobilePayee from './BenMobilePayee';

import PropTypes from 'prop-types';

class BenMobileSync extends Component {
  constructor(props) {
    super(props);
    this.isAllSelected = this.isAllSelected.bind(this);
  }

  isAllSelected() {
    const { results, selectedItems } = this.props;
    return results.length === selectedItems.length;
  }

  render() {
    const { onSelectAllClicked, content } = this.props;
    return (
      <div>
        <div className="beneficiary-table-container beneficiary-table-container-xsmall">
          <table
            className="beneficiary-table beneficiary-table-xsmall"
            cellPadding="0"
            cellSpacing="0"
          >
            <tbody
              className="beneficiary-table__is-clickable"
              onClick={() => onSelectAllClicked(null, !this.isAllSelected())}
            >
              <tr className="benheader">
                <th scope="col" className="selection-column">
                  <div className="option-select">
                    <input
                      type="checkbox"
                      name="checkbox"
                      checked={this.isAllSelected()}
                    />
                    <label />
                  </div>
                </th>
                <th>{content.selectAll}</th>
                <td />
              </tr>
            </tbody>
          </table>
          <BenMobilePayee
            results={this.props.results}
            onMobRowSelect={this.props.onMobRowSelect}
            content={this.props.content}
          />
        </div>
        <label>{content.benSyncFooterMessage}</label>
      </div>
    );
  }
}

export default BenMobileSync;

BenMobileSync.propTypes = {
  results: PropTypes.object.isRequired,
  content: PropTypes.object,
  onMobRowSelect: PropTypes.func,
  selectedItems: PropTypes.object.isRequired,
  onSelectAllClicked: PropTypes.func,
};
